module.exports = __webpack_public_path__ + "img/海通乡-c.7ba36d7a.png";